const getConnectedAgents = (conversation) => {
  const agentConnections = conversation?.agent_connections || {};

  return Object.entries(agentConnections)
    .filter(([, connection]) => !connection?.disconnected_at)
    .map(([key, connection]) => ({
      key,
      agent: connection?.agent,
      connectedAt: connection?.connected_at,
    }));
};

export default getConnectedAgents;
